export default "__VITE_ASSET__CNnkZoKb__"